export default __webpack_public_path__ + "static/media/img_tyre.edf9256c.svg";